import { assertNever } from '@kofno/piper';
import { Maybe } from 'maybeasy';
import { useEffect, useRef, useState } from 'react';
import { Link } from '../../../../../Resource/Types';
import { TPlainTextKey } from '../../../../../Translations';
import { setFilteringState, setOptionSelectedState } from './Actions';
import { getPlaceholder, isLoading, options, selectedValue } from './Computed';
import { fetchOptions, loadOptions } from './Reactions';
import { FilterOption, State, loading, ready } from './Types';
import { handleInputChange, handleSelectionChange } from './Handlers';

export const useParticipantDynamicTypeaheadSelect = (
  endpoint: Link,
  onChange: (value: FilterOption) => void,
  initialValue: Maybe<FilterOption>,
  placeholder: TPlainTextKey,
) => {
  const [state, setState] = useState<State>(loading(initialValue));

  const debouncer = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    switch (state.kind) {
      case 'filtering':
        fetchOptions(endpoint, state, setState);
        break;
      case 'loading':
        loadOptions(initialValue, endpoint, setState, state);
        break;
      case 'error':
      case 'filtered':
      case 'option-selected':
      case 'ready':
        break;
      default:
        assertNever(state);
    }
  }, [state, endpoint, initialValue]);

  return {
    state,
    handleInputChange: handleInputChange(debouncer, setFilteringState(state, setState), () =>
      setState(ready()),
    ),
    handleSelectionChange: handleSelectionChange(onChange, setOptionSelectedState(state, setState)),
    isLoading: isLoading(state),
    options: options(state),
    holder: getPlaceholder(placeholder, state),
    selectedValue: selectedValue(state),
  };
};
